import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopInfoInviteInfoUpdate, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopPlayerCancelInvite = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.PlayerCancelInvite), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        return deps.netSend({
            id: CommandCode.PlayerCancelInvite,
            props: {
                playerId: playerId,
            },
        });
    }), retry(), map(actionCoopInfoInviteInfoUpdate));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopPlayerCancelInvite.ts
// module id = 1817
// module chunks = 3